import { render, staticRenderFns } from "./SendMessageTemplateEdit.vue?vue&type=template&id=23081bda&scoped=true&lang=pug"
import script from "./SendMessageTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateEdit.vue?vue&type=style&index=0&id=23081bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23081bda",
  null
  
)

export default component.exports